<template name="visitorList">
  <div class="visitor-list-view" v-if="visitorDataList.length">
    <div class="visitor-list-content">
      <div
        class="visitor-content"
        :class="{'hide-visitor': !this.showVisitor, 'passed-invite': inviteStatus !== 1}">
        <div class="view-main" v-if="visitorDataList.length">
          <div class="visitor-list">
            <div class="handler-check row">
              <label class="col-3 checkAll">
                <input type="checkbox" name="checkAll" v-model="checkboxAll" @change='changeState'>全选
              </label>
              <div class="col-4 status" >
                已选<span class="count"> {{checkList.length}} </span>人
              </div>
              <div class="col-5 upAndDown" @click="upAndDowAll">
                <span  v-show="upAllVisitor">展开<i class="iconfont icon-down"></i></span>
                <span  v-show="downAllVisitor">收起<i class="iconfont icon-up"></i></span>
              </div>
            </div>
            <transition name="slide-fade">
              <div class="view-content" v-show="this.showVisitor" ref="visitorList">
                <div class="visitor-row" :key="index" v-for="(item, index) in visitorDataList" >
                  <div class="name row">
                    <label class="checked col-6">
                     <input type='checkbox' v-model='checkList'  name='checkboxinput' class='input-checkbox' :value=item.visitorId @click="getVisitorStatus($event)" :data-value=item.visitorStatus >{{ item.visitorName }}
                    </label>
                    <div class="visitor-status col-6"  v-if="item.visitorStatus == 1 || item.materialApproverStatus == 2 || item.materialApproverStatus == 3">
                      <span ref="visitorhide"  v-on:click="toggleVisitorUpDown(item.visitorId)">
                       <i :class="item.materialApproverStatus == 3 ? 'grey-radius' : 'red-radius' "></i><span class="text">{{ item.materialApproverStatusDesc }}</span><i class="iconfont" :class="{ 'icon-up': item.checked, 'icon-down': !item.checked}"></i>
                      </span>
                    </div>
                    <div class="visitor-status col-6"  v-else>
                      <span ref="visitorhide"  v-on:click="toggleVisitorUpDown(item.visitorId)">
                        <i :class="item.materialApproverStatus == 3 ? 'grey-radius' : 'red-radius' "></i><span class="text">{{ item.visitorStatusDesc }}</span><i class="iconfont" :class="{ 'icon-up': item.checked, 'icon-down': !item.checked}"></i>
                      </span>
                    </div> 
                  </div>
                  <div class="labelList" v-show="item.checked">
                    <div class="notification row"  v-for="(content, index) in item.labelList">
                      <div class="col-8 icon" v-if="content.lableType==1 || content.lableType==2"><img src="../../assets/images/8.png" ><span>{{content.title}}</span></div>
                      <div class="col-4 status" v-if="content.lableType==1 || content.lableType==2"><span>{{content.description}}</span></div>
                      <div class="col-8 icon" v-if="content.lableType==3 || content.lableType==4"><img src="../../assets/images/6.png"><span>{{content.title}}</span></div>
                      <div class="col-4 status" :class="{'redColor': content.descriptionType == 0}" v-if="content.lableType==3 || content.lableType==4"><span>{{content.description}}</span></div>
                    </div>
                  </div>
                  <div class="detail-info" v-if="item.isPriVisitor"  ref="visitorData" v-show="item.checked">
                    <div class="company-info" v-if="companyMaterial.length">
                      <h5 class="title" v-if="companyMaterial.length"><img src="../../assets/images/qiye.png">公司信息</h5>
                      <div class="info-content">
                        <dl class="row" v-show="item.isCompany" v-if="item.materialType==3 || item.materialType==4 || item.materialType==5" v-for="(item, index) in companyMaterial">
                          <dt class="col-5">{{item.materialTitleTemplate}}</dt>
                          <dd class="col-7 info-text">{{item.answer}}</dd>
                        </dl>
                        <dl  class="row" v-for="(one, index) in answerListCompany.materialOne">
                          <dt class="col-5">{{one.topic}}</dt>
                          <dd class="col-7 info-text">{{one.answer}}</dd>
                        </dl>
                        <dl  class="row" v-for="(one, index) in answerListCompany.materialTwo">
                          <dt class="col-5">{{one.topic}}</dt>
                          <dd class="col-7 spcial">
                            <dl  class="row" v-for="(one, idx) in one.answer">
                              <dd class="col-12">{{one}}</dd>
                            </dl>
                          </dd>
                        </dl>
                        <dl  class="row" v-for="(one, index) in answerListCompany.materialEnght">
                          <dt class="col-5">{{one.topic}}</dt>
                          <dd class="col-7 info-text" :class="{'redColor': one.optionCode == 4}">
                            <span>{{one.answer}}</span></dd>
                        </dl>
                        <dl class="row" v-if="(item.isCompany && item.materialType==9) || (item.isCompany && item.materialType==6) || (item.isCompany && item.materialType==7)" v-for="(item, index) in companyMaterial">
                          <dt class="col-5" :data-value="item.materialType">{{item.materialTitleTemplate}}</dt>
                          <dd class="col-7 info-text" @click="lookImgs"  v-if="item.materialType != 6">
                            <span  class="lookImgs" :data-value="item.answer">查看图片</span>
                          </dd>
                          <dd class="col-7 info-text" @click="lookAccessory"  v-if="item.materialType == 6">
                            <span  class="lookImgs" :data-value="item.answer">查看附件</span>
                          </dd>
                        </dl>
                        <!-- <dl class="row" v-if="item.isCompany && (item.materialType==6)" v-for="(item, index) in companyMaterial">
                          <dt class="col-5" :data-value="item.materialType" v-if="item.materialType == 6">{{item.materialTitleTemplate}}</dt>
                          <dd class="col-7 info-text" @click="lookAccessory">
                            <span  class="lookImgs" :data-value="item.answer">查看附件</span>
                          </dd>
                        </dl>
                        <dl class="row" v-if="item.isCompany && (item.materialType==7)" v-for="(item, index) in companyMaterial">
                          <dt class="col-5" :data-value="item.materialType">{{item.materialTitleTemplate}}</dt>
                          <dd class="col-7 info-text" @click="lookImgs">
                            <span  class="lookImgs" :data-value="item.answer">查看图片</span>
                          </dd>
                        </dl> -->
                      </div>
                    </div>
                   <div class="personal-info isPriVisitor-personal" >
                      <h5 class="title"><img src="../../assets/images/user.png"/>访客信息</h5>
                      <div class="info-content">
                        <dl class="row">
                          <dt class="col-5">姓名</dt>
                          <dd class="col-7  info-text">{{item.visitorName}}</dd>
                        </dl>
                        <dl class="row" v-if="item.visitorPhoneNumber">
                          <dt class="col-5">手机</dt>
                          <dd class="col-7 info-text">{{item.visitorPhoneNumber}}</dd>
                        </dl>
                        <dl class="row" v-if="item.visitorEmail">
                          <dt class="col-5">邮箱</dt>
                          <dd class="col-7 info-text">{{item.visitorEmail}}</dd>
                        </dl>
                      </div>
                      <div class="info-content">
                        <dl class="row" v-show="!item.isCompany" v-if="item.materialType==3 || item.materialType==4 || item.materialType==5"
                          v-for="(item, index) in perosonMaterial">
                          <dt class="col-5" :data-value="item.materialType">{{item.materialTitleTemplate}}</dt>
                          <dd class="col-7 info-text" :class="{'redColor': item.optionCode == 3}">
                            <span>{{item.answer}}</span>
                          </dd>
                        </dl>
                        <dl  class="row" v-for="(one, index) in answerListPerson.materialOne">
                          <dt class="col-5">{{one.topic}}</dt>
                          <dd class="col-7">{{one.answer}}</dd>
                        </dl>
                        <dl  class="row" v-for="(one, index) in answerListPerson.materialTwo">
                          <dt class="col-5">{{one.topic}}</dt>
                          <dd class="col-7 spcial">
                            <dl  class="row" v-for="(one, idx) in one.answer">
                              <dd class="col-12">{{one}}</dd>
                            </dl>
                          </dd>
                        </dl>
                        <dl  class="row" v-for="(one, index) in answerListPerson.materialEnght">
                          <dt class="col-5">{{one.topic}}</dt>
                          <dd class="col-7 info-text" :class="{'redColor': one.optionCode == 4 && one.status == 0}">
                            <span>{{one.answer}}</span></dd>
                        </dl>
                        <dl class="row" v-if="(!item.isCompany&& item.materialType==9) || (!item.isCompany&& item.materialType==6) || (!item.isCompany&& item.materialType==7)" v-for="(item, index) in perosonMaterial">
                          <dt class="col-5" :data-value="item.materialType">{{item.materialTitleTemplate}}</dt>
                          <dd class="col-7 info-text"  @click="lookImgs" v-if="item.materialType!=6">
                            <span :data-value="item.answer" class="lookImgs">查看图片</span>
                          </dd>
                          <dd class="col-7 info-text" @click="lookAccessory" v-if="item.materialType==6">
                            <span class="lookImgs" :data-value="item.answer">查看附件</span>
                          </dd>
                        </dl>
                      </div>
                    </div>
                    <div class="course-info" v-if="item.lessonList.length">
                      <h5 class="title"><img src="../../assets/images/gongsijianjie.png"/>培训课程<span>(完成度: {{lessonOverdue[index]}}/{{item.lessonList.length}})</span></h5>
                      <div v-on:click="toggleVisitorTrain(index)" class="btn-toggle-train">
                        <span ref="downArrow">展开<i class="iconfont icon-down"></i></span>
                        <span ref="upArrow" style="display: none;">收起<i class="iconfont icon-up"></i></span>
                      </div>
                      <div class="info-content" ref="child" style="display: none;">
                        <dl class="row" v-for="(item, index) in item.lessonList">
                          <dt class="col-8">{{item.lessonName}}</dt>
                          <dd class="col-4 status">{{item.lessonStatusDesc}}</dd>
                        </dl>
                      </div>
                    </div>
                  </div>
                  <div class="detail-info" v-else ref="visitorData"  v-show="item.checked">
                    <div class="personal-info">
                      <h5 class="title"><img src="../../assets/images/user.png">访客信息</h5>
                      <div class="info-content">
                        <dl class="row">
                          <dt class="col-5">姓名</dt>
                          <dd class="col-7  info-text">{{item.visitorName}}</dd>
                        </dl>
                        <dl class="row" v-if="item.visitorPhoneNumber">
                          <dt class="col-5">手机</dt>
                          <dd class="col-7 info-text">{{item.visitorPhoneNumber}}</dd>
                        </dl>
                        <dl class="row" v-if="item.visitorEmail">
                          <dt class="col-5">邮箱</dt>
                          <dd class="col-7 info-text">{{item.visitorEmail}}</dd>
                        </dl>
                      </div>
                       <div class="info-content" v-if="newPerosonMaterial[index].isPersonMaterial.length">
                        <dl class="row" v-if="array.materialType==3 || array.materialType==4 || array.materialType==5" v-for="(array, index) in newPerosonMaterial[index].isPersonMaterial">
                          <dt class="col-5">{{array.materialTitleTemplate}}</dt>
                          <dd class="col-7 info-text" :class="{'redColor': array.optionCode == 3}"><span>{{array.answer}}</span></dd>
                        </dl>
                        <dl class="row"
                         v-for="(array, idx) in OtherInvitorPerosonMaterial[index].materialOne">
                          <dt class="col-5">{{array.topic}}</dt>
                          <dd class="col-7 info-text">
                            <span>{{array.answer}}</span>
                          </dd>
                        </dl>
                        <dl class="row"
                         v-for="(array, idx) in OtherInvitorPerosonMaterial[index].materialTwo">
                          <dt class="col-5">{{array.topic}}</dt>
                          <dd class="col-7 spcial">
                            <dl  class="row" v-for="(one, index) in array.answer">
                              <dd class="col-12">{{one}}</dd>
                            </dl>
                          </dd>
                        </dl>
                        <dl class="row"  v-for="(array, idx) in OtherInvitorPerosonMaterial[index].materialEnght">
                          <dt class="col-5">{{array.topic}}</dt>
                          <dd class="col-7 info-text"  :class="{'redColor': array.optionCode == 4 && array.status == 0}">
                            <span>{{array.answer}}</span>
                          </dd>
                        </dl>
                        <dl class="row" v-if="array.materialType==9 || array.materialType==6 ||array.materialType==7" v-for="(array, index) in newPerosonMaterial[index].isPersonMaterial">
                          <dt class="col-5" :data-value="array.materialType">{{array.materialTitleTemplate}}</dt>
                          <dd class="col-7 info-text" @click="lookImgs" v-if="array.materialType!=6">
                            <span  class="lookImgs" :data-value="array.answer">查看图片</span>
                          </dd>
                          <dd class="col-7 info-text"  @click="lookAccessory" v-if="array.materialType==6">
                            <span class="lookImgs" :data-value="array.answer">查看附件{{item.answer}}</span>
                          </dd>
                        </dl>
                      </div>
                    </div>
                    <div class="course-info" v-if="item.lessonList.length">
                      <h5 class="title"><img src="../../assets/images/gongsijianjie.png">培训课程<span>(完成度: {{lessonOverdue[index]}}/{{item.lessonList.length}})</span></h5>
                      <div v-on:click="toggleVisitorTrain(index)" class="btn-toggle-train">
                        <span ref="downArrow">
                          展开<i class="iconfont icon-down"></i>
                        </span>
                        <span ref="upArrow" style="display: none;">收起<i class="iconfont icon-up"></i></span>
                      </div>
                      <div class="info-content" ref="child" style="display: none;">
                        <dl class="row" v-for="(item, index) in item.lessonList">
                          <dt class="col-8">{{item.lessonName}}</dt>
                          <dd class="col-4 lessonOverdueStatus">{{item.lessonStatusDesc}}</dd>
                        </dl>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
    <transition name="fade">
      <div class="visit-show" v-show="this.photoSwipeModal">
        <div>
          <photoSwipe ref="photoSwiper" @closePhoto="closePhoto"></photoSwipe>
        </div>
      </div>
    </transition>
    <alertModal 
      modalType="skipNotice" 
      :isModalShown="isModalShow" 
      :modalTitle="modalTitle"
      :confirmBtnName="confirmBtnNameTxt" 
      @cancel="handleCloseModal"
      @confirm="handleSkipAreaNotice"
      @closeModal="closeModalNotice"
      ></alertModal>
    <alertModal
      :isModalShown="isSelectModalShow"
      :modalTitle="selectModalTitle"
      cancelBtnName="直接入园"
      confirmBtnName="补发卡片"
      @cancel="directlyCheckIn('bind')"
      @confirm="reissueCard"
    >

    </alertModal>
    <alertModal
      :isModalShown="isPrintedModalShow"
      :modalTitle="printedModalTitle"
      cancelBtnName="直接进门"
      :confirmBtnName="printedModalConfirmBtnName"
      @cancel="directlyCheckIn('print')"
      @confirm="printCurrent"
    >
    </alertModal>
    <alertModalSecurity
      modalType="faceRecognition"
      :modalStatus="faceRecognitionStatus"
      :modalTitle="faceRecognitionModalTitle"
      :btnName="faceRecognitionModalBtnName"
      :isModalShown="isFaceRecognitionShown"
      :errMsg="faceRecognitionErrMsg"
      @closeSecurityModal="reloadLocation"
      @executeOperation="handleModalOperation"
    >
    </alertModalSecurity>
    <alertModalSecurity
      modalType="bindCard"
      :modalStatus="bindCardStatus"
      :modalTitle="bindCardModalTitle"
      :btnName="bindCardModalBtnName"
      :isModalShown="isBindCardModalShown"
      :errMsg="bindCardErrMsg"
      @closeSecurityModal="reloadLocation"
      @executeOperation="handleBindOrPrintModalOperation(bindCardStatus, bindCardStatusNum, checkInType)"
    >
    </alertModalSecurity>
    <alertModalSecurity
      modalType="printCard"
      :modalStatus="printCardStatus"
      :modalTitle="printCardModalTitle"
      :btnName="printCardModalBtnName"
      :isModalShown="isPrintCardModalShown"
      :errMsg="printCardErrMsg"
      @closeSecurityModal="reloadLocation"
      @executeOperation="handleBindOrPrintModalOperation(printCardStatus, printCardStatusNum, checkInType)"
    >
    </alertModalSecurity>
    <loading :active.sync="isLoading" :color="'#e42029'"></loading>
    <mediaSnapShot
      :isMediaSnapShotShow="isMediaSnapShotShow"
      :inviteId="parseInt(inviteId)"
      :visitorId="checkList[0]"
      @finishRecognition="handleFaceRes"
      >
    </mediaSnapShot>
  </div>
</template>

<script type="text/javascript">
  import { materialReview, checkPassOrReject, sevurityGetInvitationInfo, faceRecognition, checkVisitorHasCard, checkIn, getImageUrlByMediaId, getPrintStatus, AgreeVisitorNoticeOffline } from '@/utils/api';
  import photoSwipe from '@/components/photoSwipe.vue';
  import alertModal from '@/components/alertModal.vue';
  import alertModalSecurity from '@/components/alertModalSecurity.vue';
  import mediaSnapShot from '@/components/mediaSnapShot.vue';
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css';
  import { checkNested } from '@/utils/utils';
  import WXJS from '@/utils/wx';
  import wx from 'weixin-js-sdk';
  export default {
    name: 'visitorList',
    props: {
        inviteStatus: Number,
        progressData: Array,
        isTicket: Boolean,
        inviteId: String,
        isCheckOwner: Boolean,
        invitationStatus: Number,
        trackingType: Number,
        qrCode: String,
    },
    components: {
      photoSwipe,
      Loading,
      alertModal,
      alertModalSecurity,
      mediaSnapShot,
    },
    data() {
      return {
        visitorStatus: -1,
        visitorStatusList: [],
        showVisitor: true,
        checkedValue: [],
        items: [],
        approve: 2,
        refuse: 0,
        checkList: [],
        checkboxAll: false,
        isRefuseDisbaled: true,
        isApproveDisabled: true,
        thisModalTip: '拒绝只能选择一个',
        showTrain: false,
        trainList: false,
        companyMaterial: [],
        perosonMaterial: [],
        newCompanyMaterial: [],
        newPerosonMaterial: [],
        lessonOverdue: [],
        showProgress: false,
        visitorDataList: [],
        visitorData: [],
        photoSwipeModal: false,
        answerList: [],
        answerListPerson: [],
        answerListCompany: [],
        showVisitorList: false,
        OtherInvitorPerosonMaterial: [],
        visitorListData: false,
        divIndex: -1,
        hasMaterial: false,
        invitationId: '',
        imgs: ['http://farm4.staticflickr.com/3920/15008465772_383e697089_m.jpg','http://farm4.staticflickr.com/3902/14985871946_86abb8c56f_m.jpg','http://farm7.staticflickr.com/6175/6176698785_7dee72237e_b.jpg'],
        noVisitor: false,
        visitorMaterial: -1,
        labelArray: [],
        // code added by andy
        modalTitle: '', // common modal for alert please select visitor
        isModalShow: false,
        faceRecognitionModalTitle: '', // face recognition result
        faceRecognitionModalBtnName: '',
        faceRecognitionStatus: false,
        faceRecognitionErrMsg: '',
        faceRecognitionCanReTake: false,
        isFaceRecognitionShown: false,
        /* bind card */
        selectModalTitle: '', // select checkin or reissue card
        isSelectModalShow: false,
        bindCardModalTitle: '',
        bindCardModalBtnName: '',
        bindCardStatus: false,
        bindCardErrMsg: '',
        isBindCardModalShown: false,
        visitorIdx: 0,
        bindCardStatusNum: 0,
        currentVisitor: {},
        isLoading: false,
        /* print card */
        printedModalTitle: '',
        isPrintedModalShow: false,
        printedModalConfirmBtnName: '',
        printCardModalTitle: '',
        printCardModalBtnName: '',
        printCardStatus: false,
        printCardErrMsg: '',
        isPrintCardModalShown: false,
        printCardStatusNum: 0,
        cardId: 0,
        checkCode: '',
        getPrintStatusTimer: null,
        isMediaSnapShotShow: false,
        // code added by andy end
        upAllVisitor: false,
        downAllVisitor: true,
        lessonList: [],

        //test data 
        confirmBtnNameTxt: '',
        faceRecognitionOffLineStatus: '',

        propsQrCode: '',
        checkInType: 0,
      };
    },
    watch: {
      'checkList': {
        handler () {
          if(this.checkList.length !=0 ) {
            this.isRefuseDisbaled = false;
            this.isApproveDisabled = false;
          } else {
            this.isRefuseDisbaled = true;
            this.isApproveDisabled = true;
          }
          if(this.checkList.length === this.visitorDataList.length) {
             this.checkboxAll = true;
          } else {
            this.checkboxAll = false;
          }
          this.$emit('checkVisitorList', this.checkList);
        },
        deep: true
      },
      inviteId(newValue, oldValue) {
        // console.log(newValue,oldValue);
        this.invitationId = newValue;
        this.comment(this.invitationId);
      }
    },
    update() {
    },
    created() {
      // invisitor detail
      this.comment(this.inviteId);
    },
    mounted() {
    },
    methods: {
      comment(inviteId) {
        sevurityGetInvitationInfo(inviteId).then((res) => {
          if (checkNested(res, 'data', 'content', 'model')) {
            // console.log('详情全部');
            // console.log(res.data.content.model);
            this.$emit('checkVisitorList', this.checkList);
            if (res.data.content.model) {
              this.visitorData = res.data.content.model.visitorList;
              this.getData(this.visitorData);
              this.visitorDataList.forEach((x) => { x.checked = false});
              this.isTicketOwner = res.data.content.model.isTicketOwner;
              this.isGoodsListChecker = res.data.content.model.isGoodsListChecker;
              // console.log('isGoodsListChecker==' + this.isGoodsListChecker);
              this.$emit('isGoodsListChecker', this.isGoodsListChecker);
              var  arrayList = [];
              this.OtherInvitorPerosonMaterial.map( function(argument,idx) {
                if ( (idx==0 && argument) || idx >0) {
                  const carCode =  argument.isPersonMaterial.map((item,index) => {
                    if (item.optionCode==3) {
                      if (arrayList.findIndex(x => x === idx) == -1) {
                        arrayList.push(idx)
                      }
                    }
                  });
                  const hazardous =  argument.materialEnght.map((item,index) => {
                    if (item.optionCode==4 && item.status == 0) {
                      if (arrayList.findIndex(x => x === idx) == -1) {
                        arrayList.push(idx)
                      }
                    }
                  });
                }
              })
              // console.log('其他访客')
              // console.log(this.OtherInvitorPerosonMaterial)
              // console.log(arrayList);
              this.initShow(arrayList);
                if (res.data.content.model.inviteGoodsList) {
                  this.inviteGoodsList = res.data.content.model.inviteGoodsList;
                  // console.log('收发货列表')
                  // console.log(this.inviteGoodsList);
                  this.$emit('inviteGoodsList', this.inviteGoodsList);
                }
            }
            // console.log('接收的isTicket== ' + this.isTicket);
          }
        });
      },
      initShow(arrayList) {
        var that = this;
        // console.log(this.visitorDataList)
        this.visitorDataList.forEach( function(item, index) {
          if (item.isPriVisitor) {
            that.toggleVisitorUpDown(item.visitorId);
          }
        })
        this.visitorDataList.forEach( function(item, index) {
          if (!item.isPriVisitor) {
            arrayList.forEach(x => {
              if ( index == x ) {
                that.toggleVisitorUpDown(item.visitorId);
              }
            });
          }
        })
      },
      toggleVisitor: function() {
        this.showVisitor = !this.showVisitor;
      },
      toggleVisitorTrain: function(index) {
        if (this.$refs.child[index].style.display == 'none') {
          this.$refs.child[index].style.display = 'block';
          this.$refs.downArrow[index].style.display = 'none';
          this.$refs.upArrow[index].style.display = 'block';
        } else {
          this.$refs.child[index].style.display = 'none';
          this.$refs.downArrow[index].style.display = 'block';
          this.$refs.upArrow[index].style.display = 'none';
        }
      },
      upAndDowAll() {
        var that = this;
        if (this.downAllVisitor) {
          this.downAllVisitor = false;
          this.upAllVisitor = true;
          this.visitorDataList.forEach( function(item, index) {
            that.toggleVisitorUpAll(item.visitorId);
          });
        } else {
          this.downAllVisitor = true;
          this.upAllVisitor = false;
          this.visitorDataList.forEach( function(item, index) {
            that.toggleVisitorUpDown(item.visitorId);
          });
        }   
      },
      toggleVisitorUpAll(id) {
        const { visitorDataList } = this;
        const user = visitorDataList.find(x => x.visitorId == id);
        if (user) {
          user.checked = false;
        }
        for (var i=0; i<visitorDataList.length; i++){
            var obj = new Object();
            obj.checked = visitorDataList[i].checked;
            obj.avatar = visitorDataList[i].avatar;
            obj.deptName = visitorDataList[i].deptName;
            obj.gender = visitorDataList[i].gender;
            obj.hasMaterial = visitorDataList[i].hasMaterial;
            obj.isCurrentVisitor = visitorDataList[i].isCurrentVisitor;
            obj.isPriVisitor = visitorDataList[i].isPriVisitor;
            obj.lessonList = visitorDataList[i].lessonList;
            obj.materialApproverStatus = visitorDataList[i].materialApproverStatus;
            obj.materialApproverStatusDesc = visitorDataList[i].materialApproverStatusDesc;
            obj.materialOptionInfoList = visitorDataList[i].materialOptionInfoList;
            obj.labelList = visitorDataList[i].labelList;
            obj.qrCode = visitorDataList[i].qrCode;
            obj.visitorEmail = visitorDataList[i].visitorEmail;
            obj.visitorId = visitorDataList[i].visitorId;
            obj.visitorName = visitorDataList[i].visitorName;
            obj.visitorPhoneNumber = visitorDataList[i].visitorPhoneNumber;
            obj.visitorStatus = visitorDataList[i].visitorStatus;
            obj.visitorStatusDesc = visitorDataList[i].visitorStatusDesc;
            this.$set(this.visitorDataList,i,obj)
        }
        this.getData(this.visitorDataList);
       //console.log(this.visitorDataList);
      },
      toggleVisitorDownAll(id) {

        const { visitorDataList } = this;
        const user = visitorDataList.find(x => x.visitorId == id);
        if (user) {
          user.checked = true;
        }
        for (var i=0; i<visitorDataList.length; i++){
            var obj = new Object();
            obj.checked = visitorDataList[i].checked;
            obj.avatar = visitorDataList[i].avatar;
            obj.deptName = visitorDataList[i].deptName;
            obj.gender = visitorDataList[i].gender;
            obj.hasMaterial = visitorDataList[i].hasMaterial;
            obj.isCurrentVisitor = visitorDataList[i].isCurrentVisitor;
            obj.isPriVisitor = visitorDataList[i].isPriVisitor;
            obj.lessonList = visitorDataList[i].lessonList;
            obj.materialApproverStatus = visitorDataList[i].materialApproverStatus;
            obj.materialApproverStatusDesc = visitorDataList[i].materialApproverStatusDesc;
            obj.materialOptionInfoList = visitorDataList[i].materialOptionInfoList;
            obj.labelList = visitorDataList[i].labelList;
            obj.qrCode = visitorDataList[i].qrCode;
            obj.visitorEmail = visitorDataList[i].visitorEmail;
            obj.visitorId = visitorDataList[i].visitorId;
            obj.visitorName = visitorDataList[i].visitorName;
            obj.visitorPhoneNumber = visitorDataList[i].visitorPhoneNumber;
            obj.visitorStatus = visitorDataList[i].visitorStatus;
            obj.visitorStatusDesc = visitorDataList[i].visitorStatusDesc;
            this.$set(this.visitorDataList,i,obj)
        }
        this.getData(this.visitorDataList);
       //console.log(this.visitorDataList);
      },
      toggleVisitorUpDown(id) {
        const { visitorDataList } = this;
        const user = visitorDataList.find(x => x.visitorId == id);
        if (user) {
          user.checked = !user.checked;
        }
        for (var i=0; i<visitorDataList.length; i++){
            var obj = new Object();
            obj.checked = visitorDataList[i].checked;
            obj.avatar = visitorDataList[i].avatar;
            obj.deptName = visitorDataList[i].deptName;
            obj.gender = visitorDataList[i].gender;
            obj.hasMaterial = visitorDataList[i].hasMaterial;
            obj.isCurrentVisitor = visitorDataList[i].isCurrentVisitor;
            obj.isPriVisitor = visitorDataList[i].isPriVisitor;
            obj.lessonList = visitorDataList[i].lessonList;
            obj.materialApproverStatus = visitorDataList[i].materialApproverStatus;
            obj.materialApproverStatusDesc = visitorDataList[i].materialApproverStatusDesc;
            obj.materialOptionInfoList = visitorDataList[i].materialOptionInfoList;
            obj.labelList = visitorDataList[i].labelList;
            obj.qrCode = visitorDataList[i].qrCode;
            obj.visitorEmail = visitorDataList[i].visitorEmail;
            obj.visitorId = visitorDataList[i].visitorId;
            obj.visitorName = visitorDataList[i].visitorName;
            obj.visitorPhoneNumber = visitorDataList[i].visitorPhoneNumber;
            obj.visitorStatus = visitorDataList[i].visitorStatus;
            obj.visitorStatusDesc = visitorDataList[i].visitorStatusDesc;
            this.$set(this.visitorDataList,i,obj)
        }
        this.getData(this.visitorDataList);
       //console.log(this.visitorDataList);
      },
      showReason: function() {
        this.$emit('popupStatus', true);
      },
      changeState: function(e) {
        this.checkList = [];
        if (this.checkboxAll) {
          this.visitorDataList.forEach( (value, index) => {
            this.checkList.push(value.visitorId);
          })
        }
      },
      showReasonOne: function() {
        if (this.checkList.length == 1) {
          //console.log(this.visitorStatusList.filter(x => x.value == this.checkList[0])[0].status);
          if (this.visitorStatusList.filter(x => x.value == this.checkList[0])[0].status == 1 ||
            this.visitorStatusList.filter(x => x.value == this.checkList[0])[0].status == 5) {
            this.$emit('popupStatus', true, this.checkList);
          } else {
            this.$emit('invitatisonStatusShow', true, '该访客已经入园，不能进行拒绝操作');
          }
        } else {
          this.$emit('popupTip', true, this.thisModalTip);
        }
      },
      showReasonAll: function() {
        // console.log('访客是否有入园')
        // console.log(this.invitationStatus);
        if (this.invitationStatus != 1  && this.invitationStatus != 11 && this.invitationStatus != 12 && this.invitationStatus != 13 && this.invitationStatus != 32) {
          this.$emit("invitatisonStatusShow", true, '已经有访客入园，不能进行拒绝操作');
        } else {
          this.$emit('popupGmModal', true);
        }
      },
      approveAll: function() {
        if(this.checkList.length) {
          // console.log(this.checkList);
          const getAgreeList = {
            'invitationId': this.inviteId,
            'idList': this.checkList,
            'isPass': 1,
            'reason': ''
          }
          this.$emit("isLoadingShow", true);
          materialReview(getAgreeList).then((res) => {
            // console.log(res);
            // console.log(res.data.content.message);
            if (res.data.content.status == 1) {
              this.$emit("isLoadingShow", false);
              window.location.reload();
            } else {
              this.$emit("isLoadingShow", false);
              this.$emit('approveAllModal', true, res.data.content.message);
            }
          });
        }
      },
      approveAllList: function() {
        if(this.inviteId) {
          const getAgreeList = {
            'id': this.inviteId,
            'isPass': true,
            'reason': ''
          }
          this.$emit("isLoadingShow", true);
          checkPassOrReject(getAgreeList).then((res) => {
             if (res.data.content.status == 1) {
              this.$emit("isLoadingShow", false);
              window.location.reload();
             } else {
              this.$emit("isLoadingShow", false);
              this.$emit('approveAllListModal', true, res.data.content.message);
             }
          });
        }
      },
      toggleProgress: function() {
        this.showProgress = !this.showProgress;
      },
      getData(objData) {
        //console.log('传送数据');
        //console.log(objData);
        this.visitorDataList = objData;
        const hasMaterial = this.visitorDataList.map( function(item, index) {
          if (item.hasMaterial) {
            return true;
          } else {
            return false;
          }
        });
        this.hasMaterial =  hasMaterial.findIndex(x => x==true) != -1
        //console.log('是否配置')
        //console.log(this.hasMaterial);
        const newArrayMaterial = this.visitorDataList.map( function(item, index) {
          if (!item.isPriVisitor) {
            const newArray = item.materialOptionInfoList.filter(function(i) {
              return i.isCompany == false;
            });
            const rObj = {};
            rObj.isPersonMaterial = newArray;
            return rObj;
          }
        });
        //console.log(newArrayMaterial);
        this.newPerosonMaterial = newArrayMaterial;
        if (this.newPerosonMaterial.length) {
          const materialAnswerTemplate = this.newPerosonMaterial.map( function(array, index) {
            if(array) {
              array.materialTwo = [];
              array.materialEnght = [];
              array.materialOne = [];
              const list = array.isPersonMaterial;
              const newList = list.map( function(item, index) {
                if (item.materialType == 1) {
                  const newArrayList = JSON.parse(item.answer);
                  var materialTitleTemplate = item.materialTitleTemplate;
                  const AnswerTemplate = JSON.parse(item.materialAnswerTemplate)[newArrayList[0]];
                  const newObj = {
                    'topic': materialTitleTemplate,
                    'answer': AnswerTemplate,
                  }
                  array.materialOne.push(newObj);  
                } else if (item.materialType == 2) {
                  const newArrayList = JSON.parse(item.answer);
                  var materialTitleTemplate = item.materialTitleTemplate;
                  const AnswerTemplate = JSON.parse(item.materialAnswerTemplate);
                  var newArrayTwo = [];
                  const answerIndex = newArrayList.map(function(view,index) {
                    newArrayTwo.push(AnswerTemplate[view]);
                  });
                  const newObj = {
                    'topic': materialTitleTemplate,
                    'answer': newArrayTwo,
                  }
                  array.materialTwo.push(newObj);
                } else if (item.materialType == 8) {
                  const newArrayList = JSON.parse(item.answer);
                  var materialTitleTemplate = item.materialTitleTemplate;
                  var optionCode = item.optionCode;
                  const AnswerTemplate = JSON.parse(item.materialAnswerTemplate)[newArrayList[0]];
                  const status = newArrayList[0];
                  const newObj = {
                    'topic': materialTitleTemplate,
                    'answer': AnswerTemplate,
                    'optionCode': optionCode,
                    'status': status,

                  }
                  array.materialEnght.push(newObj);
                }
              });
            }
            return array;
          });
          this.OtherInvitorPerosonMaterial = materialAnswerTemplate;
        }
       
       // console.log(this.newPerosonMaterial.materialAnswerTemplat);
        const arrList = [];
        for(var i=0;i<this.visitorDataList.length;i++) {
          const materialOptionInfoList = this.visitorDataList[i].materialOptionInfoList;
          const iscompany = [];
          const personList = [];
          const lessonList = this.visitorDataList[i].lessonList;
          this.lessonList = lessonList;
          if (this.visitorDataList[i].isPriVisitor) {
            iscompany = materialOptionInfoList.filter(function(i) {
                return i.isCompany == true;
            });
            personList = materialOptionInfoList.filter(function(i) {
                return i.isCompany == false;
            });
            this.companyMaterial = iscompany;
            this.perosonMaterial = personList;
          }
          const lessonOverdue = [];
          for (var j = 0; j<this.lessonList.length; j++) {
            if(this.lessonList[j].lessonStatus == 2) { 
             lessonOverdue.push(this.lessonList[j]);
            }
          }  
          arrList.push(lessonOverdue.length);
        }
        this.lessonOverdue = arrList;

        this.selectOption(this.companyMaterial,'company');
        this.selectOption(this.perosonMaterial,'person');
      },
      selectOption(dataArray,status) {
        var rObj = {
          'materialTwo': [],
          'materialEnght': [],
          'materialOne': [],
        };
        if (dataArray.length) {
          var answerIndex = [];
          const materialAnswerTemplate = dataArray.map( function(item, index) {
            if(item) {
              if (item.materialType == 2) {
                const newArrayList = JSON.parse(item.answer);
                var materialTitleTemplate = item.materialTitleTemplate;
                var AnswerTemplate = JSON.parse(item.materialAnswerTemplate);
                var newObj = {};
                var newArrayTwo = [];
                const answerIndex = newArrayList.map(function(view,index) {
                  newArrayTwo.push(AnswerTemplate[view])  
                });
                newObj = {
                  'topic': materialTitleTemplate,
                  'answer': newArrayTwo,
                }
                rObj.materialTwo.push(newObj);
              } else if (item.materialType == 8) {
                const newArrayList = JSON.parse(item.answer);
                var materialTitleTemplate = item.materialTitleTemplate;
                var optionCode = item.optionCode;
                const AnswerTemplate = JSON.parse(item.materialAnswerTemplate)[newArrayList[0]];
                const status = newArrayList[0];
                const newObj = {
                  'topic': materialTitleTemplate,
                  'answer': AnswerTemplate,
                  'optionCode': optionCode,
                  'status': status,
                }
                rObj.materialEnght.push(newObj);
              } else if (item.materialType == 1) {
                const newArrayList = JSON.parse(item.answer);
                var materialTitleTemplate = item.materialTitleTemplate;
                var AnswerTemplate = JSON.parse(item.materialAnswerTemplate)[newArrayList[0]];
                const newObj = {
                  'topic': materialTitleTemplate,
                  'answer': AnswerTemplate, 
                }
                rObj.materialOne.push(newObj); 
              }
            }
          });
          //console.log(rObj);
          if (status == 'person') {
            this.answerListPerson = rObj;
          } else {
             this.answerListCompany = rObj;
          }
        }
      },
      lookImgs(e) {
        //console.log(e.target.dataset.value);
        const imgs = e.target.dataset.value;
        const imgArr = JSON.parse(imgs);
        if (imgArr) {
          this.photoSwipeModal = true;
          this.$refs.photoSwiper.loadPhoto(imgArr);
          this.$emit('showLookImgs',true);
        }
      },
      lookAccessory(e) {
        //console.log(e.target.dataset.value);
        const materials = e.target.dataset.value;
        const newArray = JSON.parse(materials);
        var newArraymaterialList = [];
        var newArraymaterialName = [];
        for (var j=0; j<newArray.length; j++) {
          const current = newArray[j];
          const idx = current.lastIndexOf(",");
          const list = current.substring(0, idx);
          const name = current.substring(idx+1, current.length);
          if(list!='') {
            newArraymaterialList.push(list);
            newArraymaterialName.push(name);
          }
        }
        // console.log(newArraymaterialList);
        // console.log(newArraymaterialName);
        if(newArraymaterialList.length) {
          this.photoSwipeModal = true;
          this.$refs.photoSwiper.loadMaterial(newArraymaterialList,newArraymaterialName);
          this.$emit('showLookImgs',true);
        }
      },
      closePhoto() {
        this.photoSwipeModal = false;
      },
      hideVisitor(visitor,approver,gm) {
        // console.log(visitor,approver,gm);
        this.visitorListData = visitor ? true : false;
        // console.log(this.visitorListData);
        if (visitor || approver || gm) {
          this.showVisitorList = true;
        } else {
          this.showVisitorList = false;
        }
      },
      getVisitorStatus(e) {
        // console.log(e)
        // console.log(e.target._value);
        // console.log(e.target.dataset.value);
        const visitorList = {
          'status': e.target.dataset.value,
          'value': e.target._value
        }
        if ( this.visitorStatusList.findIndex(x => x.value === visitorList.value) == -1) {
           this.visitorStatusList.push(visitorList);
        }
        // console.log(this.visitorStatusList);
      },
      // code added by andy:
      handleCloseModal() {
        this.checkList = [];
        this.isModalShow = false;
      },
      handleFaceRes(res) {
        // if photo taken by usermedia
        this.isMediaSnapShotShow = false;
        if (checkNested(res, 'data', 'content', 'model')) {
          const { model, message, status } = res.data.content;
          this.isFaceRecognitionShown = true;
          this.$emit('isBindCardModalShown', true);
          this.faceRecognitionStatus = model ? model.isIdentical : false;
          this.faceRecognitionCanReTake = model && !model.isIdentical;
          this.faceRecognitionModalTitle = this.faceRecognitionStatus ? '恭喜您！识别成功' : '很抱歉！识别失败';
          this.faceRecognitionErrMsg = model ? '' : message; // err occured
          this.faceRecognitionOffLineStatus = status === 5;
          if (status === 1 || status === 2) {
            this.faceRecognitionModalBtnName = model ? (model.isIdentical ? '确定' : '重新拍照') : '确定';
          } else if (status === 5) {
            this.faceRecognitionModalBtnName = '访客已经线下阅读，跳过这一步';
          } else {
            this.faceRecognitionModalBtnName = '确定';
          }
          //this.faceRecognitionModalBtnName = model ? ((model.isIdentical ? '确定' : '重新拍照') : '确定';
        }
      },
      handleFaceRecognition() {
        const checkedLength = this.checkList.length;
        if (!checkedLength) {
          this.modalTitle = '请选择一位访客';
          this.isModalShow = true;
        } else if (checkedLength > 1) {
          this.modalTitle = '只能选择一位访客进行人脸识别';
          this.isModalShow = true;
        } else {
          // check logic first before take photo, call faceRecognition twice
          // #1 fileData: '', check logic purely, show alert modal if logic checking failed
          // #2 if logic is passed call it again with photo
          const inviteId = parseInt(this.inviteId);
          const visitorId = this.checkList[0];
          this.isLoading = true;
          this.isFaceRecognitionShown = false;
          this.$emit('isBindCardModalShown', false);
          faceRecognition({ ticketId: inviteId, visitorId: visitorId, fileData: '' }).then(res => {
            this.isLoading = false;
            if (checkNested(res, 'data', 'content')) {
              const { status } = res.data.content;
              if (status !== 1) {
                if (status == 5) {
                  this.modalTitle = res.data.content.message;
                  this.confirmBtnNameTxt = '访客已经线下阅读，跳过这一步';
                  this.isModalShow = true;
                } else {
                  this.confirmBtnNameTxt = '';
                  this.modalTitle = res.data.content.message;
                  this.isModalShow = true;
                }
              } else {
                  const supported = 'mediaDevices' in navigator;
                  if (supported) {
                    this.isMediaSnapShotShow = true;
                  } else {
                    // take photo and do actual face recognition
                    this.getImgUrlByMediaId().then(imgUrl => {
                      return faceRecognition({ ticketId: inviteId, visitorId: visitorId, fileData: imgUrl })
                    })
                      .then(res => {
                        this.isLoading = false;
                        this.handleFaceRes(res);
                      });
                  }
              }
            }
          });
        }
      },
      handleSkipAreaNotice() {
        //console.log(this.confirmBtnNameTxt)
        if (this.confirmBtnNameTxt) {
          const visitorId = this.checkList[0];
          AgreeVisitorNoticeOffline(visitorId).then((res) => {
            if (checkNested(res, 'data', 'content', 'model')) {
              console.log(res.data.content)
              if (res.data.content.status === 1) {
                this.handleFaceRecognition();
              }
            }
          })
        } else {
          this.handleCloseModal();
        }  
      },
      closeModalNotice(e) {
        e.stopPropagation();
        this.isModalShow = false;
      },

      // comobine three callback in promise style
      // #1
      takePhotoViaWx() {
        return new Promise((resolve, reject) => {
          WXJS.getWXSign().then(() => {
            wx.chooseImage({
              count: 1,
              sizeType: ['original', 'compressed'],
              sourceType: ['camera'],
              defaultCameraMode: "normal",
              isSaveToAlbum: 0,
              success: function (res) {
                var localId = res.localIds[0];
                resolve(localId);
              },
              error(res) {
                alert(`error:${ res }`);
              },
            });
          });
        });
      },
      // #2
      getImgMediaId() {
        return new Promise((resolve, reject) => {
          const self = this;
          self.takePhotoViaWx().then(res => {
            wx.uploadImage({
              localId: res, // 需要上传的图片的本地ID，由chooseImage接口获得
              isShowProgressTips: 1, // 默认为1，显示进度提示
              success: function (res) {
                self.isLoading = true; // show our own loading spin
                let mediaId = res.serverId; // 返回图片的服务器端ID
                resolve(mediaId);
              },
              error(res) {
                alert(`error:${ res }`);
              },
            }); 
          });
        });
      },
      // #3
      getImgUrlByMediaId() {
        this.isFaceRecognitionShown = false;
        this.$emit('isBindCardModalShown', false);
        return new Promise((resolve, reject) => {
          this.getImgMediaId().then(mediaId => {
            return getImageUrlByMediaId(mediaId);
          })
            .then(res => {
              if (checkNested(res, 'data', 'content', 'model')) {
                const { model } = res.data.content;
                resolve(model);
              }
            });
        });
      },
      reloadLocation() {
        location.reload();
        window.location.reload();
      },
      handleModalOperation() {
        if ((!this.faceRecognitionStatus && this.faceRecognitionCanReTake) || this.faceRecognitionOffLineStatus) {
          // try re-take photo
          if (this.faceRecognitionOffLineStatus) {
            const visitorId = this.checkList[0];
            AgreeVisitorNoticeOffline(visitorId).then((res) => {
              if (checkNested(res, 'data', 'content', 'model')) {
                if (res.data.content.status === 1) {
                  this.handleFaceRecognition();
                }
              }
            })
          } else {
            this.handleFaceRecognition(); 
          } 
        } else {
          this.reloadLocation();
        }
      },
      // TODO: Considering improve code below: 
      emitScanQrCode() {
        let timerId = null;
        const gap = 1000;
        this.$emit('scanQRCode');
        // wait until we get scaned result
        timerId= setInterval(() => {
          this.propsQrCode = this.$props.qrCode;
          if (this.propsQrCode) {
            clearInterval(timerId);
            const visitorId = this.checkList[this.visitorIdx]; // get current visitorId
            const inviteId = parseInt(this.inviteId);
            const checkInType = 1;
            this.checkInType = 1;
            this.handleCheckIn(inviteId, visitorId, this.checkInType, this.propsQrCode, 'bind');
          }
        }, gap);
      },
      handleCheckVisitorHasCard(cardType, inviteId, visitorId) {
        checkVisitorHasCard(cardType, inviteId, visitorId).then((res) => {
          if (checkNested(res, 'data', 'content', 'model')) {
            let { model } = res.data.content;
            //--- test code
            // model = true;
            //--- test code end
            const currentVisitor = this.visitorDataList.find(x => x.visitorId === visitorId);
            this.currentVisitor = currentVisitor;
            // console.log(`has card already: ${model}`);
            // if modal equals to false, scan qr code
            if (!model.isSend) {
              cardType === 1 && this.emitScanQrCode(); // notify parent scope to scan qr
              cardType === 2 && this.handleCheckIn(inviteId, visitorId, cardType, '', 'print');
            } else {
              // show modal for directly checkin or reissue
              if (cardType === 1) {
                this.selectModalTitle = `${currentVisitor.visitorName}已经发过卡片，是否要挂失补发？`;
                this.isSelectModalShow = true;
              } else {
                this.printedModalTitle = `${currentVisitor.visitorName} ${model.isPrintSuccess ? '已经打印过卡片' : '打印失败'}，是否要重新打印？`; 
                this.printedModalConfirmBtnName = model.isPrintSuccess ? '打印新卡' : '重新打印';
                this.isPrintedModalShow = true;
              }
            }
          }
        });
      },
      handleBindOrPrint(type) {
        this.visitorIdx = 0;
        const checkedLength = this.checkList.length;
        const cardType = type; // 1: bind normal card, 2: print card
        const inviteId = this.inviteId;
        const visitorId = this.checkList[this.visitorIdx]; // get current visitorId
        this.checkInType = cardType;
        if (!checkedLength) {
          this.modalTitle = '请选择一位访客';
          this.isModalShow = true;
        } else {
          this.handleCheckVisitorHasCard(this.checkInType, inviteId, visitorId);
        }
      },
      handleNext(hasNext, type) {
        if (hasNext) {
          this.visitorIdx++;
          const inviteId = this.inviteId;
          const visitorId = this.checkList[this.visitorIdx]; // get current visitorId
          const cardType = type;
          this.currentVisitor = this.visitorDataList.find(x => x.visitorId === visitorId);
          //test data 
          this.handleCheckVisitorHasCard(cardType, inviteId, visitorId);
        } else {
          this.reloadLocation();
        }
      },
      handleReBindOrPrintAfterFailed(type) {
        const cardType = type;
        const inviteId = this.inviteId;
        const visitorId = this.checkList[this.visitorIdx]; // get current visitorId
        this.handleCheckVisitorHasCard(cardType, inviteId, visitorId);
      },
      handleBindOrPrintModalOperation(status, statusNum, cardType) {
        const hasNext = (this.visitorIdx + 1) < this.checkList.length;
        this.isBindCardModalShown = false;
        this.isPrintCardModalShown = false;
        this.$emit('isBindCardModalShown', false);
        this.getPrintStatusTimer = null; // reset timer to null
        if (!status) {
          // bind/print card special logic: 
          // if model return is false, but current bind/print status is 'failed' not 'error', try bind/print next
          if (statusNum === 4) { 
            this.handleNext(hasNext, cardType);
          } else if (statusNum === 2) {
            // try re-bind or re-print for current visitor
            if (cardType==2) {
              this.handleReBindOrPrintAfterFailed(cardType);
            } else {
              this.emitScanQrCode();
            }
          } else if (statusNum == 5) { // offline reading
            //console.log("this.visitorIdx=="+this.visitorIdx)
            const visitorId = this.checkList[this.visitorIdx];
            const inviteId = parseInt(this.inviteId);
            AgreeVisitorNoticeOffline(visitorId).then((res) => {
              if (checkNested(res, 'data', 'content', 'model')) {
                if (res.data.content.status === 1) {
                  if (cardType == 1) {
                    this.handleCheckIn(inviteId, visitorId, cardType, this.propsQrCode, 'bind');
                  } else {
                    this.handleCheckIn(inviteId, visitorId, cardType, '', 'print');
                  }
                }
              }
            })
          } else {
            this.reloadLocation();
          }
        } else {
          this.handleNext(hasNext, cardType);
        }
      },
      bindAlertSecurityModalRes(model, status, message, checkInType,  btnType) {
        const currentVisitor = this.currentVisitor;
        this.getPrintStatusTimer = null;
        clearInterval(this.getPrintStatusTimer);
        this.checkInType = checkInType;
        if (btnType === 'bind') {
          this.isBindCardModalShown = true;
          this.$emit('isBindCardModalShown', true);
          this.bindCardStatus = status === 1;
          this.bindCardErrMsg = status === 1 ? '' : message;
          this.bindCardModalTitle = this.bindCardStatus ? `${currentVisitor.visitorName} ${checkInType === 1 ? '绑定成功' : '入园成功'}` : 
                                    `${currentVisitor.visitorName} ${checkInType === 1 ? '绑定失败' : '入园失败'}`;
          this.bindCardStatusNum = status;
          this.bindCardModalBtnName = (status === 1 || status === 4) && (this.visitorIdx + 1) < this.checkList.length ? '下一个' : status === 2 ? '重新扫码' : status === 5 ? '访客已经线下阅读，跳过这一步' : '确定';
        } else {
            this.isPrintCardModalShown = true;
            this.$emit('isBindCardModalShown', true);
            this.printCardStatus = status === 1;
            this.printCardErrMsg = status === 1 ? '' : message;
            this.printCardModalTitle = this.printCardStatus ? `${currentVisitor.visitorName} ${checkInType === 2 ? '准备打印' : '进门成功'}` : 
                                       `${currentVisitor.visitorName} ${checkInType === 2 ? '打印失败' : '进门失败'}`;
            //this.printCardStatusNum = status === 1 ? 1 : 0; // print card is not likely to have 2, 3, 4, if occured, we reset it to 0 to prevent re-print at this point
            this.printCardStatusNum = status;
            this.printCardModalBtnName = (status === 1 || status === 4) && (this.visitorIdx + 1) < this.checkList.length ? '下一个' : status === 5 ? '访客已经线下阅读，跳过这一步' : '确定';
            
            if (model && model.cardId && model.checkCode) {
              // get print status
              const duration = 500;
              this.getPrintStatusTimer = setInterval(() => {
                clearInterval(this.getPrintStatusTimer);
                getPrintStatus(model.cardId, model.checkCode).then((res) => {
                  if (checkNested(res, 'data', 'content', 'status')) {
                    const { model } = res.data.content;
                    this.printCardModalTitle = ((model === 1 && `${currentVisitor.visitorName} 排队中`) || (model === 2 && `${currentVisitor.visitorName} 打印中`) || (model === 3 && `${currentVisitor.visitorName} 打印成功`) || (model === 4 && `${currentVisitor.visitorName} 打印失败`)) || this.printCardModalTitle;
                    this.printCardStatusNum = model === 4 ? 2 : this.printCardStatusNum; // 2 for re-print
                  }
                });
              }, duration);
            }
        }
      },
      handleCheckIn(inviteId, visitorId, checkInType, qrCode, btnType) {
        this.isLoading = true;
        console.log('visitorId== '+visitorId);
        checkIn(inviteId, visitorId, checkInType, qrCode).then((res) => {
          this.isLoading = false;
          this.$emit('getCheckInRes'); // nofity parent scope to reset qrResult
          if (checkNested(res, 'data', 'content', 'status')) {
            const { model, status, message } = res.data.content;
            // debugger;
            /**
             * res.data.content.status
             * 1: success, model is true, try bind/print next ?
             * 2: failed: current visitor binded/printed failed, try bind/print again ?
             * 3: error: error occured, nothinig to bind/print at all
             * 4: accessDenied: current visitor binded/printed failed, try bind/print next ?
             */
            //this.bindAlertSecurityModalRes(model, status, message, checkInType, btnType);
            this.bindAlertSecurityModalRes(model, status, message, checkInType, btnType);
          }
        });
      },
      // modal shows after check if has card === true
      directlyCheckIn(btnType) {
        const inviteId = parseInt(this.inviteId);
        const { visitorId } = this.currentVisitor;
        this.isSelectModalShow = false;
        this.isPrintedModalShow = false;
        this.checkInType = 3;
        this.handleCheckIn(inviteId, visitorId, this.checkInType, '', btnType);
      },
      reissueCard() {
        this.isSelectModalShow = false;
        this.emitScanQrCode(); // notify parent scope to scan qr code
      },
      printCurrent() {
        this.isPrintedModalShow = false;
        const inviteId = parseInt(this.inviteId);
        const checkInType = 2;
        const { visitorId } = this.currentVisitor;
        this.checkInType = checkInType;
        this.handleCheckIn(inviteId, visitorId, this.checkInType, '', 'print');
      },
      // code added by andy end
    },
  };
</script>

<style scoped lang="scss">
.visitor-content:not(.passed-invite) {
  padding-bottom: 50px;
}
.visitor-list-view {
}
.visitor-empty {
  text-align: center;
  margin-bottom: 85px;
  .icon {
    width: 86px;
    height: 86px;
    margin: 0 auto 15px;
  }
  h5,
  p {
    font-size: 13px;
  }
  h5 {
    font-weight: bold;
  }
  .btn-back {
    width: 125px;
    height: 42px;
    border-radius: 5px;
    font-size: 15px;
    line-height: 28px;
    color: #fff;
    margin-top: 5px;
    background-image: linear-gradient(69deg, #f36443, #e42029);
  }
}
.course-info {
  position: relative;
  .title {
    span {
      padding-left: 7px;
      font-size: 13px;
      font-weight: normal;
      color: #4a4a4a;
    }
    img {
      width: 12px !important;
    }
  }
  .btn-toggle-train {
    cursor: pointer;
    position: absolute;
    top: 15px;
    right: 0;
    span {
      font-size: 13px;
    }
    i {
      transform: scale(.75,.75);
      margin-left: 5px;
      font-size: 12px;
      display: inline-block;
      margin-right: -2px;
    }
  }
}
.view-header.visiteInformation {
  position: relative;
  margin-bottom: 0;
  h4 {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 0;
  }
  .btn-toggle {
    position: absolute;
    top: 0;
    right: 0;
    span {
      font-size: 13px;
    }
    i {
      transform: scale(.75,.75);
      margin-left: 5px;
    }
  }
}
.visitor-list {
  width: 100%;
  color: #4a4a4a;
  .handler-check {
    padding: 20px 0;
    margin: 0;
    border-bottom: 1px solid rgba(101, 101, 101, 0.15);
    align-items: center;
    label.checkAll {
      font-size: 14px;
      color: #929292;
      margin: 0;
      padding-right: 0;
      input[type='checkbox'] {
        width: 23px;
        height: 23px;
        appearance: none;
        background-color: #fff;
        outline: none;
        background: url(../../assets/images/copy-21.png) no-repeat center;
        vertical-align: text-bottom;
        margin-bottom: -1px;
        margin-right: 7px;
      }
      input[type='checkbox']:checked {
        border: none;
        background: url(../../assets/images/zhengque.png) no-repeat center;
      }
    }
    .status {
      text-align: left;
      font-size: 14px;
      color: #929292;
      .count {
        font-size: 14px;
        font-weight: 600;
        color: #e42029;
      }
    }
    .upAndDown {
      text-align: right;
      padding-right: 25px;
      cursor: pointer;
      span {
        font-size: 14px;
        color: #4a4a4a;
        padding-right: 5px;
      }
      i {
        transform: scale(0.75, 0.75);
        margin-left: 5px;
        font-size: 14px;
        display: inline-block;
        margin-right: -2px;
      }
    }
  }
  .view-content {
    margin-top: 0;
    padding: 0 10px;
  }
  .visitor-row {
    background: #fff;
    font-size: 13px;
    // box-shadow: 0 0 15px rgba(100,100,100,.1);
    position: relative;
    margin-bottom: 20px;
    line-height: 1;
    border-bottom: 1px solid rgba(101, 101, 101, 0.15);
    h5 {
      font-size: 13px;
      font-weight: bold;
      margin-bottom: 15px;
      line-height: 1;
    }
    .visitor-status  {
      text-align: right;
      font-size: 12px;
      color: #4a4a4a;
      cursor: pointer;
      &:after {
        content: '';
        display: block;
        position: absolute;
        bottom: -11px;
        left: -11px;
        width: 22px;
        height: 22px;
        border-radius: 11px;
        background: rgba(255,255,255,0.4);
      }
      .red-radius {
        display: inline-block;
        margin-right: 5px;
        width: 9px;
        height: 9px;
        background-color: #ff0e19;
        border-radius: 100%;
      }
      .grey-radius {
        margin-right: 5px;
        display: inline-block;
        width: 9px;
        height: 9px;
        border-radius: 100%;
        background-color: #929292;
      }
      .text {
        margin-right: 10px;
      }
      i {
        transform: scale(0.75, 0.75);
        font-size: 10px;
      }
      i.icon-up {
        color: #e42029;
      }
    }
    .name {
      margin-bottom: 15px;
      margin-left: 0;
      align-items: center;
      padding: 18px 0;
      margin: 0;
      & > div:first-child {
        margin-right: 10px;
      }
      label {
        font-weight: bold;
      }
      input.input-checkbox[type='checkbox'] {
        width: 23px;
        height: 23px;
        appearance: none;
        background-color: #fff;
        outline: none;
        vertical-align: text-bottom;
        margin-bottom: -4px;
        margin-right: 7px;
        background: url(../../assets/images/copy-21.png) no-repeat center;
      }
      input.input-checkbox[type='checkbox']:checked {
        background: url(../../assets/images/11-copy.png) no-repeat center;
      }
      label {
        line-height: 22px;
        margin: 0;
      }
    }
    .labelList {
      margin-bottom: 15px;
    }
    .notification {
      padding: 8px 15px 8px 40px;
      .icon {
        text-align: left;
        padding-right: 0;
        img {
          margin-right: 5px;
        }
        span {
          //display: inline-block;
          vertical-align: middle;
          font-size: 13px;
          color: #4a4a4a;
        }
      }
      .status {
        text-align: right;
        font-size: 13px;
        color: #4a4a4a;
        span {
          display: inline-block;
          word-break: break-all;
        }
      }
    }
    .detail-info {
      padding: 0 40px;
      .company-info {
        padding-top: 0;
        border-bottom: 1px solid rgba(101, 101, 101, 0.15);
        span {
          cursor: pointer;
        }
      }

      .personal-info {
        padding-top: 0;
        border-bottom: 1px solid rgba(101, 101, 101, 0.15);
        &.isPriVisitor-personal {
          padding-top: 15px;
        }
        span {
          cursor: pointer;
        }
      }
      .course-info {
        padding-top: 15px;
      }
    }
    dl {
      margin-bottom: 8px;
      dt {
        padding-right: 0;
        font-weight: normal;
        color: #929292;
        font-size: 13px;
        line-height: 18px;
      }
      .col-3 {
        color: #929292;
        font-size: 13px;
      }
      div {
        color: #929292;
      }
      dd {
        line-height: 18px;

        &.info-text {
          padding-left: 0;
          .lookImgs {
            text-decoration: underline;
            color: #e42029;
          }
        }
        &.col-3 {
          text-align: right;
          padding-left: 0;
          span {
            max-width: 52px;
          }
        }
      }
    }
    .approver-info {
      img {
        border-radius: 50%;
        width: 34px;
        height: 34px;
        border: 1px solid #eee;
        margin-right: 10px;
      }
      .status {
        width: 100%;
        height: 28px;
        border-radius: 14px;
        background-color: #f4f4f4;
        display: inline-block;
        line-height: 28px;
        font-size: 12px;
        text-align: center;
        color: #9b9b9b;
      }
      .status-red {
        color: #e42029;
      }
    }
    .info-content {
      span {
        & + span {
          padding-left: 10px;
        }
      }
      .status {
        text-align: right;
        color: #929292;
      }
      .lessonOverdueStatus {
        text-align: right;
        color: #929292;
      }
    }
  }
}
.visitor-content {
  background-color: #fff;
  box-shadow: 0 0 15px rgba(100, 100, 100, 0.1);
  .view-main {
  }
}
.visitor-content.hide-visitor {
  padding-bottom: 0;
  .view-main {
    border-radius: 10px;
    // padding-bottom: 5px;
    margin-bottom: 20px;
    box-shadow: 0 10px 25px rgba(100,100,100,.1);
  }
}
.progress-list {
  width: 100%;
  margin: 0 auto;
  padding: 10px 20px;
  color: #4a4a4a;
  margin-bottom: 70px;
  margin-top: 20px;
  .btn-toggle-train {
    cursor: pointer;
    text-align: right;
    font-size: 13px;
    padding-right: 25px;
    i {
      font-size: 12px;
      display: inline-block;
      transform: scale(0.75, 0.75);
      margin-left: 5px;
      margin-right: -5px;
    }
  }
  .view-header {
    h4 {
      font-size: 16px;
    }
  }
  .view-content {
    padding: 10px;
  }
  ul {
    padding: 0;
    list-style: none;
    position: relative;
    &:before {
      content: '';
      width: 2px;
      background: #cecece;
      display: block;
      position: absolute;
      top: 6px;
      left: 0;
      height: calc(100% - 12px);
    }
    .isShow:nth-of-type(5) {
      padding-bottom: 25px;
    }
  }
  li {
    padding-left: 24px;
    position: relative;
    font-size: 12px;
    line-height: 1;
    padding-bottom: 25px;
    &:nth-of-type(5) {
      padding-bottom: 0;
    }
    &:before,
    &:after {
      content: '';
      position: absolute;
      top: 0;
      left: 10px;
      display: block;
      background: #999;
    }
    &:before {
      width: 12px;
      height: 12px;
      border-radius: 6px;
      opacity: 0.18;
    }
    &:after {
      width: 6px;
      height: 6px;
      border-radius: 3px;
      top: 3px;
      left: 13px;
      transform: scale(0.9,0.9);
    }
    &:first-child {
      color: #e42029;
      &:before,
      &:after {
        background: #ff2137;
      }
    }
    &:last-child {
      padding-bottom: 0;
    }
    .message {
      text-align: right;
      line-height: 18px;
      word-break: break-all;
    }
  }
}
.handle-bar {
  background: #fff;
  padding: 15px 20px;
  box-shadow: 0 0 15px rgba(100,100,100,.15);
  align-items: center;
  label.checkAll {
    font-size: 16px;
    color: #929292;
    margin: 0;
    input[type='checkbox'] {
      width: 23px;
      height: 23px;
      appearance: none;
      background-color: #fff;
      outline: none;
      background: url(../../assets/images/copy-21.png) no-repeat center;
      vertical-align: text-bottom;
      margin-bottom: -1px;
      margin-right: 7px;
    }
    input[type='checkbox']:checked {
      border: none;
      background: url(../../assets/images/zhengque.png) no-repeat center;
    }
  }
  .btn {
    width: 100%;
  }
  .refuse {
    cursor: pointer;
    padding-right: 10px;
    .btn {
      &:hover {
        color: #9b9b9b;
      }
    }
  }
  .approve {
    cursor: pointer;
    padding-left: .1em;
    padding-right: .1em;
  }
}
.show-popup {
  position: absolute;
}
.reason {
  display: none;
}
.visitor-row {
  .detail-info {
    .title {
      img {
        vertical-align: text-top;
        margin-right: 5px;
        width: 16px;
      }
    }
  }
}

.visit-show {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top:0;
  z-index: 1032;
  background:rgba(0, 0, 0, 0.4);
  .invisitListContent {
    position: absolute;
    bottom: 0;
  }
}

.visitor-list {
  .spcial {
    padding: 0;
    margin: 0;
    dl,
    dd {
      margin-bottom: 2px;
    }
  }
}

.redColor {
  span {
    color: #e42029;
    display: inline-block;
    word-break: break-all;
  }
}
</style>
